export const USER_SESSION_TIMEZONE = "America/Atikokan"; // GMT-5 timezone

export const LOCAL_USER_TIMEZONE =
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const DATE_FORMAT = "DD-MM-YYYY";

export const FALLBACK_TIME_ZONE = "America/New_York";
